import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import "./pritsHeader.css";

const PritsHeader = () => {

  const [isOpen, setIsOpen] = useState(false);


  const openTabContianer = () => {
    let container = document.getElementById("topBarGov");
    if (container.classList.contains("show")) {
      container.classList.remove("show");
      setIsOpen(false);
    } else {
      container.classList.add("show");
      setIsOpen(true);
    }
  };

  return (
    <div className="topBar">
      <div className="topBarContent">
        <div className="topBarLink" onClick={() => openTabContianer()}>
          <img
            src="https://assets-global.website-files.com/606ce22566af383df2754cf8/606ce22566af3872f4754d08_guidi-icon.png"
            alt="gov"
            width={27}
          />
          <div className="topBarText">
            <strong style={{fontWeight: 700}}>Portal oficial del Gobierno de Puerto Rico</strong>
          </div>
          <div className="topBarText">
            <FontAwesomeIcon icon={isOpen? faChevronUp : faChevronDown} style={{fontWeight: 700}} />
          </div>
        </div>
      </div>
      <div id="topBarGov" className="topBarBottomContent">
        <div className="topBarBottomContainer">
          <div className="leftLine">
            <div className="topBarText">
              <strong>Un sitio web oficial .pr.gov</strong> pertenece a una
              organización oficial del Gobierno de Puerto Rico.
            </div>
          </div>
          <div className="leftLine">
            <div className="topBarText">
              <strong>Los sitios web seguros .pr.gov usan HTTPS,</strong> lo que
              significa que usted se conectó de forma segura a un sitio web.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PritsHeader;
